export default "__VITE_ASSET__CsbmDVto__"